import { render, staticRenderFns } from "./DrawdownBreadcrumbs.vue?vue&type=template&id=048e6942&scoped=true"
import script from "./DrawdownBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./DrawdownBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./DrawdownBreadcrumbs.vue?vue&type=style&index=0&id=048e6942&prod&lang=css"
import style1 from "./DrawdownBreadcrumbs.vue?vue&type=style&index=1&id=048e6942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048e6942",
  null
  
)

export default component.exports